import { Box, Link } from '@mui/material';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

export function jsonMarkdown(value: unknown): string {
  return '```json\n' + JSON.stringify(value, null, 2) + '\n```';
}

export function maybeJsonMarkdown(text: string): string {
  try {
    return jsonMarkdown(JSON.parse(text));
  } catch {
    return text;
  }
}

export default function Markdown({ children }: { children: string }) {
  return (
    <Box
      sx={{
        maxWidth: '100%',
        minWidth: 0,
        overflowWrap: 'anywhere',
        '& code': {
          fontFamily: 'monospace',
          fontSize: '0.85em',
          bgcolor: 'action.hover',
          borderRadius: 0.5,
          px: 0.5,
        },
        '& pre': {
          m: 0,
          p: 1,
          bgcolor: 'action.hover',
          borderRadius: 1,
          whiteSpace: 'pre-wrap',
          overflowWrap: 'anywhere',
          wordBreak: 'break-word',
        },
        '& pre code': { bgcolor: 'transparent', p: 0, fontSize: '0.8em', whiteSpace: 'pre-wrap' },
      }}
    >
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          a: ({ node, ...props }) => <Link {...props} target="_blank" rel="noopener noreferrer" />,
        }}
      >
        {children}
      </ReactMarkdown>
    </Box>
  );
}
